import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FileHelperService {

  constructor() { }

  returnFileTypeFromFileName(fileName: string): string {
    let fileType: string = 'other';
    let fileExt: string = fileName.split('.').pop().toLowerCase();
    switch (fileExt) {
      case ('jpg'):
      case ('jpeg'):
      case ('png'):
      case ('gif'):
        fileType = 'image';
        break;
      default:
        fileType = 'other';
        break;
    }
    return fileType;
  }
}
